import { FC, HTMLAttributes } from 'react';

import { MenuFoldOutlined } from '@ant-design/icons';

import { Flex, Layout, theme } from 'antd';
import cn from 'classnames';

import { Balance } from 'entities/User';
import { TelegramBotIcon } from 'features/Telegram';
import { commonApi } from 'shared/api/commonApi.ts';
import { useMedia } from 'shared/hooks';
import { Logo } from 'shared/ui';
import { Hamburger, Notifications, UserInfo } from 'widgets/Header';
import { useSidebarSlice } from 'widgets/Sidebar';

import styles from './Header.module.scss';

interface IHeaderProps extends HTMLAttributes<HTMLElement> {}

export const Header: FC<IHeaderProps> = ({ className, ...props }) => {
	const { data: appConfig } = commonApi.useGetAppConfigQuery();
	const isMobile = useMedia();
	const isXl = useMedia('xl');
	const { collapsed, toggleCollapsed } = useSidebarSlice();
	const {
		token: { colorBgBase },
	} = theme.useToken();

	return (
		<Layout.Header {...props} className={cn(className, styles.headerContainer)}>
			<Flex className={styles.header} align="center" justify="space-between" style={{ background: colorBgBase }}>
				{!isXl && (
					<button className={cn(styles.trigger, { [styles.collapsed]: collapsed })} onClick={toggleCollapsed}>
						<MenuFoldOutlined />
					</button>
				)}

				{isXl && <Logo collapsed={false} className={styles.logo} />}

				{appConfig?.user && (
					<Flex gap={8} align="center">
						<TelegramBotIcon />
						{!isMobile && <Balance />}
						<Notifications />
						<UserInfo />
						{isXl && <Hamburger />}
					</Flex>
				)}
			</Flex>
		</Layout.Header>
	);
};
